module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Gd-Ha-Ic-Jb.3ee87b9a.png";